import { fromEvent } from 'rxjs';

// eslint-disable-next-line import/prefer-default-export
export const getPelandoEvents$ = () =>
  fromEvent(window.document.documentElement, 'PelandoEvent');
